<template>
  <v-form v-model="formValid">
    <v-container v-if="loading.type !== 'getFleet' && !localLoading">
      <!-- App -->
      <v-row v-show="showApplicationSelect">
        <v-col cols="12" sm="2">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" v-bind="attrs" v-on="on">
                {{ getAppNameByAppId(fleet.AppId) }}
              </v-btn>
            </template>
            <v-list v-if="availableApplications.length">
              <v-list-item
                v-for="(item, index) in availableApplications"
                :key="index"
                selected
                @click="appId = item.ID"
              >
                <v-list-item-title>{{ item.ShortName }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="d-flex align-center">
        <!-- Region -->
        <v-col v-show="showUserRegionsSelect" cols="12" sm="2">
          <v-select
            v-model="region"
            :items="userRegions"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REGION')"
            outlined
            hide-details
            :loading="loading.state && loading.type === 'getUserRegions'"
            :rules="regionRules"
            required
            :disabled="currentFleetId > 0"
          ></v-select>
        </v-col>
        <!-- Name -->
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="name"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.NAME')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.NAME')"
            outlined
            hide-details
            :rules="nameRules"
            required
          ></v-text-field>
        </v-col>
        <!-- Valid From -->
        <v-col cols="12" sm="3">
          <v-menu
            v-model="validFromPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  validFrom !== '0001-01-01T00:00:00Z' && validFrom !== null
                    ? new Date(validFrom).toISOString().substr(0, 10)
                    : ''
                "
                :label="$vuetify.lang.t('$vuetify.VALID_FROM')"
                :placeholder="$vuetify.lang.t('$vuetify.VALID_FROM')"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="validFrom = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="
                validFrom !== '0001-01-01T00:00:00Z' && validFrom !== null
                  ? new Date(validFrom).toISOString().substr(0, 10)
                  : ''
              "
              @change="validFrom = new Date($event).toISOString()"
              @input="validFromPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- Valid To -->
        <v-col cols="12" sm="3">
          <v-menu
            v-model="validToPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  validTo !== '0001-01-01T00:00:00Z' && validTo !== null
                    ? new Date(validTo).toISOString().substr(0, 10)
                    : ''
                "
                :label="$vuetify.lang.t('$vuetify.VALID_TO')"
                :placeholder="$vuetify.lang.t('$vuetify.VALID_TO')"
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="validTo = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="
                validTo !== '0001-01-01T00:00:00Z' && validTo !== null
                  ? new Date(validTo).toISOString().substr(0, 10)
                  : ''
              "
              @change="validTo = new Date($event).toISOString()"
              @input="validToPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- Type -->
        <v-col cols="12" sm="2">
          <!-- <v-menu offset-y :disabled="currentFleetId > 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" v-bind="attrs" v-on="on">
                {{ type }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in fleetTypes"
                :key="index"
                selected
                @click="type = item"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
          <v-select
            v-model="type"
            :items="fleetTypes"
            :disabled="currentFleetId > 0"
            :label="$vuetify.lang.t('$vuetify.TYPE')"
            outlined
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" class="d-flex align-center">
          <v-checkbox
            v-model="startSessionWithLPR"
            :label="
              $vuetify.lang.t(
                '$vuetify.EDIT_WHITELISTS.START_SESSIONS_WITH_LPR'
              )
            "
            hide-details
            class="ma-0"
          ></v-checkbox>
          <v-tooltip bottom class="ml-2">
            <template #activator="data">
              <v-icon small v-on="data.on">
                mdi-help
              </v-icon>
            </template>
            <span>
              {{
                $vuetify.lang.t(
                  '$vuetify.EDIT_WHITELISTS.START_SESSIONS_WITH_LPR_DESCRIPTION'
                )
              }}
            </span>
          </v-tooltip>
        </v-col>
        <!-- Valid in -->
        <v-row class="d-flex align-center col-12 py-0 pr-0">
          <v-col cols="12" sm="12" md="3">
            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" v-on="on">
                  {{ fleet.ValidInType }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="validInType = 'PLACES'">
                  <v-list-item-title>PLACES</v-list-item-title>
                </v-list-item>
                <v-list-item @click="validInType = 'ZONES'">
                  <v-list-item-title>ZONES</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <v-select
              v-model="validInType"
              :value="validInType"
              :items="['PLACES', 'ZONES']"
              :label="$vuetify.lang.t('$vuetify.WHITELISTS.VALID_IN')"
              outlined
              hide-details
              required
            >
              <template v-slot:selection="{ item }">
                {{ $vuetify.lang.t(`$vuetify.IN_${item}`) }}
              </template>
              <template v-slot:item="{ item }">
                {{ $vuetify.lang.t(`$vuetify.IN_${item}`) }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" class="pr-0">
            <v-autocomplete
              v-if="fleet.ValidInType === 'PLACES'"
              v-model="places"
              :items="userPlaces"
              :rules="placeRules"
              item-text="AddressText"
              multiple
              hide-details
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              clearable
              outlined
              label="Select place(s)"
              prepend-inner-icon="mdi-map-marker"
              :loading="loading.state && loading.type === 'getUserPlaces'"
              @focus="getUserPlaces({ region: region })"
            />
            <v-autocomplete
              v-if="fleet.ValidInType === 'ZONES'"
              v-model="zones"
              :items="userZones"
              :rules="zoneRules"
              multiple
              hide-details
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              clearable
              outlined
              label="Select zone(s)"
              :loading="loading.state && loading.type === 'getUserZones'"
              @focus="getUserZones({ region })"
            />
          </v-col>
        </v-row>
        <!-- Default daily limit -->
        <v-col cols="4">
          <v-text-field
            v-model.number="dailyLimitInCentsPerUser"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DEF_DAILY_LIMIT')"
            :placeholder="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.DEF_DAILY_LIMIT')
            "
            outlined
            hide-details
            type="number"
          >
            <template v-slot:append>
              <div class="d-flex align-center">
                {{ fleet.Currency }}
              </div>
            </template>
          </v-text-field>
        </v-col>
        <!-- Default monthly limit -->
        <v-col cols="4">
          <v-text-field
            v-model.number="monthlyLimitInCentsPerUser"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DEF_MONTHLY_LIMIT')"
            :placeholder="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.DEF_MONTHLY_LIMIT')
            "
            outlined
            hide-details
            type="number"
          >
            <template v-slot:append>
              <div class="d-flex align-center">
                {{ fleet.Currency }}
              </div>
            </template>
          </v-text-field>
        </v-col>
        <!-- Maximum number of users -->
        <v-col cols="4">
          <v-text-field
            v-model.number="maxNumberOfUsers"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.MAX_NUMBER_OF_USERS')"
            :placeholder="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.MAX_NUMBER_OF_USERS')
            "
            outlined
            hide-details
            append-icon="mdi-account"
            type="number"
          >
          </v-text-field>
        </v-col>
        <!-- Managers -->
        <v-col cols="12">
          <v-autocomplete
            v-model="selectedManagers"
            :items="owners"
            item-text="Owner.Name"
            return-object
            chips
            outlined
            :label="$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.ADD_MANAGER')"
            multiple
            hide-details
            prepend-inner-icon="mdi-account"
            dense
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                class="my-2"
                @click="data.select"
                @click:close="removeSelectedManager(data.item)"
              >
                {{ data.item.Owner.Name }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content>
                  {{ data.item.Owner.Name }}
                </v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-avatar>
                  <template v-slot:default>
                    <avatar
                      :badge="false"
                      :text="data.item.Owner.Name"
                      class="secondary"
                    />
                  </template>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ data.item.Owner.Name || '' }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="fleet.Managers.length && fleet.Users && fleet.Users.length"
          cols="12"
          class="px-0"
          hover
        >
          <v-list subheader dense>
            <v-subheader>
              {{ $vuetify.lang.t('$vuetify.EDIT_FLEETS.MANAGERS') }}
            </v-subheader>
            <v-list-item
              v-for="manager in fleet.Managers"
              :key="manager.Id"
              outline
              class="highlight"
            >
              <!-- <v-list-item-avatar>
                <v-img :alt="`${chat.title} avatar`" :src="chat.avatar"></v-img>
              </v-list-item-avatar> -->

              <v-list-item-content>
                <v-list-item-title v-if="manager.Owner">
                  {{ manager.Owner.Name || '' }}
                </v-list-item-title>
                <v-divider></v-divider>
              </v-list-item-content>

              <v-list-item-action>
                <!-- <v-icon :color="chat.active ? 'deep-purple accent-4' : 'grey'">
                  mdi-message-outline
                </v-icon> -->
                <!-- <ul class="dropdown-menu">
                  <li
                    v-for="(fleetUserId, fleetUserName) in fleetUserChoices"
                    :key="fleetUserId"
                  >
                    <a
                      href=""
                      ng-click="setRestrictedToFleetUser(manager, fleetUserId)"
                      >{{ fleetUserName }}</a
                    >
                  </li>
                </ul> -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" color="dark" dark small v-on="on">
                      {{
                        fleetUserChoices[manager.RestrictedToFleetUserId] ||
                          'UNKNOWN'
                      }}
                      <v-icon>
                        {{
                          attrs['aria-expanded'] === 'true'
                            ? 'mdi-chevron-up'
                            : 'mdi-chevron-down'
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="(fleetUserId, funame) in fleetUserChoices"
                      :key="fleetUserId"
                      @click="setRestrictedToFleetUser(manager, funame)"
                    >
                      <v-list-item-title>{{ fleetUserId }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <!-- Description for app -->
        <v-col cols="12" sm="6">
          <v-textarea
            v-model="appInfoText"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DESC_FOR_APP')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.DESC_FOR_APP')"
            outlined
            hide-details
            height="100"
          >
          </v-textarea>
        </v-col>
        <!-- Description -->
        <v-col cols="12" sm="6">
          <v-textarea
            v-model="description"
            :label="$vuetify.lang.t('$vuetify.DESCRIPTION')"
            :placeholder="$vuetify.lang.t('$vuetify.DESCRIPTION')"
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
        <!-- RegistrationOpenUntil -->
        <v-col cols="12" sm="4">
          <v-menu
            v-model="registrationOpenUntilPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  registrationOpenUntil !== '0001-01-01T00:00:00Z' &&
                  registrationOpenUntil !== null
                    ? new Date(registrationOpenUntil)
                        .toISOString()
                        .substr(0, 10)
                    : ''
                "
                :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_OPEN_TIL')"
                :placeholder="
                  $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_OPEN_TIL')
                "
                append-icon="mdi-calendar"
                readonly
                outlined
                hide-details
                clearable
                v-bind="attrs"
                @click:clear="registrationOpenUntil = null"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="
                registrationOpenUntil !== '0001-01-01T00:00:00Z' &&
                registrationOpenUntil !== null
                  ? new Date(registrationOpenUntil).toISOString().substr(0, 10)
                  : ''
              "
              @change="registrationOpenUntil = new Date($event).toISOString()"
              @input="registrationOpenUntilPicker = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <!-- App Registration Code -->
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="appRegistrationCode"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_CODE_APP')"
            :placeholder="$vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_CODE_APP')"
            required
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <!-- Notification Emails -->
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="notificationEmails"
            :label="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_NOTIFICATION_EMAIL')
            "
            :placeholder="
              $vuetify.lang.t('$vuetify.EDIT_FLEETS.REG_NOTIFICATION_EMAIL')
            "
            required
            outlined
            hide-details
          ></v-text-field>
        </v-col>

        <!-- Email body after successful registration -->
        <v-col cols="12" sm="6">
          <v-textarea
            v-model="approvalMessage"
            :label="
              $vuetify.lang.t(
                '$vuetify.EDIT_FLEETS.EMAIL_BODY_AFTER_REGISTRATION'
              )
            "
            :placeholder="
              $vuetify.lang.t(
                '$vuetify.EDIT_FLEETS.EMAIL_BODY_AFTER_REGISTRATION'
              )
            "
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
        <!-- Registration request received message -->
        <v-col v-if="!autoApprove" cols="12" sm="6">
          <v-textarea
            v-model="registrationRequestReceivedMessage"
            :label="$vuetify.lang.t('$vuetify.EMAIL_REQ_INFO')"
            :placeholder="$vuetify.lang.t('$vuetify.EMAIL_REQ_INFO')"
            outlined
            hide-details
            height="100"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="5">
          <v-checkbox
            v-model="autoApprove"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.AUTO_APPROVE')"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="5">
          <v-checkbox
            v-model="resetUsedLimitsEachMonth"
            :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.RESET_LIMITS')"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4">
          <v-checkbox
            v-model="archived"
            :label="$vuetify.lang.t('$vuetify.ARCHIVED')"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
    <v-toolbar v-else class="elevation-0">
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-toolbar
      v-if="
        (loading.state && loading.type === 'getFleet') ||
          (loading.type === '' && !fleet)
      "
      class="elevation-0"
    >
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="secondary"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-toolbar>
  </v-form>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Avatar from '@/components/commonComponents/Avatar'

export default {
  name: 'FleetForm',
  components: {
    Avatar
  },
  mixins: [formatDate],
  data() {
    return {
      formValid: false,
      regionRules: [v => v.length >= 2 || 'Regioon on nõutud'],
      nameRules: [v => v.length >= 2 || 'Nimetus on nõutud'],
      placeRules: [
        v =>
          (this.validInType === 'PLACES' &&
            this.validInType !== 'ZONES' &&
            v.length >= 1) ||
          this.$vuetify.lang.t('EDIT_WHITELIST.PLACE_REQUIRED')
      ],
      zoneRules: [
        v =>
          (this.validInType === 'ZONES' &&
            this.validInType !== 'PLACES' &&
            v.length >= 1) ||
          'Tsoon on nõutud'
      ],
      showApplicationSelect: false,
      showUserRegionsSelect: false,
      registrationOpenUntilPicker: false,
      validFromPicker: false,
      validToPicker: false,
      owners: [],
      localLoading: true
    }
  },
  computed: {
    ...mapGetters('authentication', ['user']),
    ...mapGetters('app', ['loading', 'availableApplications']),
    ...mapGetters('fleets', ['fleet', 'fleetTypes', 'currentFleetId']),
    ...mapGetters('users', ['userRegions', 'userPlaces', 'userZones', 'users']),
    fleetUserChoices() {
      const choices = { 0: '<None>' }
      if (this.fleet.Users && this.fleet.Users.length) {
        this.fleet.Users.forEach(element => {
          choices[`${element.ID}`] = element.Name
        })
      }
      return choices
    },
    region: {
      get() {
        return this.fleet.Region
      },
      set(value) {
        this.setFleetValue({
          key: 'Region',
          value
        })
      }
    },
    type: {
      get() {
        return this.fleet.Type
      },
      set(value) {
        this.setFleetValue({
          key: 'Type',
          value
        })
      }
    },
    name: {
      get() {
        return this.fleet.Name
      },
      set(value) {
        this.setFleetValue({
          key: 'Name',
          value
        })
      }
    },
    appId: {
      get() {
        return this.fleet.AppID
      },
      set(value) {
        this.setFleetValue({
          key: 'AppId',
          value
        })
      }
    },
    validInType: {
      get() {
        return this.fleet.ValidInType
      },
      set(value) {
        this.setFleetValue({
          key: 'ValidInType',
          value
        })
      }
    },
    places: {
      get() {
        return this.fleet.Places
      },
      set(value) {
        this.setFleetValue({
          key: 'Places',
          value
        })
      }
    },
    zones: {
      get() {
        return this.fleet.Zones
      },
      set(value) {
        this.setFleetValue({
          key: 'Zones',
          value
        })
      }
    },
    validFrom: {
      get() {
        return this.fleet.ValidFrom
      },
      set(value) {
        this.setFleetValue({
          key: 'ValidFrom',
          value
        })
      }
    },
    validTo: {
      get() {
        return this.fleet.ValidTo
      },
      set(value) {
        this.setFleetValue({
          key: 'ValidTo',
          value
        })
      }
    },
    registrationOpenUntil: {
      get() {
        return this.fleet.RegistrationOpenUntil
      },
      set(value) {
        this.setFleetValue({
          key: 'RegistrationOpenUntil',
          value
        })
      }
    },
    appRegistrationCode: {
      get() {
        return this.fleet.AppRegistrationCode
      },
      set(value) {
        this.setFleetValue({
          key: 'AppRegistrationCode',
          value
        })
      }
    },
    notificationEmails: {
      get() {
        return this.fleet.NotificationEmails
      },
      set(value) {
        this.setFleetValue({
          key: 'NotificationEmails',
          value
        })
      }
    },
    description: {
      get() {
        return this.fleet.Description
      },
      set(value) {
        this.setFleetValue({
          key: 'Description',
          value
        })
      }
    },
    appInfoText: {
      get() {
        return this.fleet.AppInfoText
      },
      set(value) {
        this.setFleetValue({
          key: 'AppInfoText',
          value
        })
      }
    },
    registrationRequestReceivedMessage: {
      get() {
        return this.fleet.RegistrationRequestReceivedMessage
          ? this.fleet.RegistrationRequestReceivedMessage
          : 'Your registration request has been received. You will receive a confirmation email when your registration is confirmed.'
      },
      set(value) {
        this.setFleetValue({
          key: 'RegistrationRequestReceivedMessage',
          value
        })
      }
    },
    approvalMessage: {
      get() {
        return this.fleet.ApprovalMessage
      },
      set(value) {
        this.setFleetValue({
          key: 'ApprovalMessage',
          value
        })
      }
    },
    autoApprove: {
      get() {
        return this.fleet.AutoApprove
      },
      set(value) {
        this.setFleetValue({
          key: 'AutoApprove',
          value
        })
      }
    },
    archived: {
      get() {
        return this.fleet.Archived
      },
      set(value) {
        this.setFleetValue({
          key: 'Archived',
          value
        })
      }
    },
    startSessionWithLPR: {
      get() {
        return this.fleet.StartSessionWithLPR
      },
      set(value) {
        this.setFleetValue({
          key: 'StartSessionWithLPR',
          value
        })
      }
    },
    resetUsedLimitsEachMonth: {
      get() {
        return this.fleet.ResetUsedLimitsEachMonth
      },
      set(value) {
        this.setFleetValue({
          key: 'ResetUsedLimitsEachMonth',
          value
        })
      }
    },
    dailyLimitInCentsPerUser: {
      get() {
        return this.fleet.DailyLimitInCentsPerUser
      },
      set(value) {
        this.setFleetValue({
          key: 'DailyLimitInCentsPerUser',
          value
        })
      }
    },
    monthlyLimitInCentsPerUser: {
      get() {
        return this.fleet.MonthlyLimitInCentsPerUser
      },
      set(value) {
        this.setFleetValue({
          key: 'MonthlyLimitInCentsPerUser',
          value
        })
      }
    },
    maxNumberOfUsers: {
      get() {
        return this.fleet.MaxNumberOfUsers
      },
      set(value) {
        this.setFleetValue({
          key: 'MaxNumberOfUsers',
          value
        })
      }
    },
    managers: {
      get() {
        return this.fleet.Managers
      },
      set(value) {
        const list = []
        if (Array.isArray(value)) {
          value.forEach(element => {
            const existingManager = this.selectedManagers.find(
              manager => manager.Id === element.Id
            )
            if (!existingManager) {
              list.push({
                CanEditUsers: true,
                OwnerId: element.Owner.Id,
                Owner: { ...element },
                FleetId: this.currentFleetId
              })
            }
          })
        } else {
          const existingManager = this.selectedManagers.find(
            manager => manager.Id === value.Id
          )
          if (!existingManager) {
            list.push({
              CanEditUsers: true,
              OwnerId: value.Owner.Id,
              Owner: { value },
              FleetId: this.currentFleetId
            })
          }
        }
      }
    },
    selectedManagers: {
      get() {
        return this.fleet.Managers || []
      },
      set(value) {
        this.setFleetValue({
          key: 'Managers',
          value
        })
      }
    }
  },
  watch: {
    users() {
      this.users.forEach(element => {
        this.owners.push({
          CanEditUsers: true,
          OwnerId: element.Id,
          Owner: { ...element },
          FleetId: this.currentFleetId
        })
      })
    },
    currentFleetId(newValue) {
      if (!newValue) return
      if (newValue !== null && newValue > 0) {
        this.getFleet(this.currentFleetId)
      }
      this.getUserRegions()
      if (this.fleet.ValidInType === 'PLACES') {
        this.getUserPlaces({ region: this.region })
      } else if (this.fleet.ValidInType === 'ZONES') {
        this.getUserZones({ region: this.region })
      }
      this.getAvailableApplications()
    },
    formValid() {
      this.$emit(this.formValid ? 'valid' : 'invalid')
    }
  },
  async created() {
    if (this.currentFleetId > 0) {
      this.getFleet(this.currentFleetId)
    }

    await this.getUserRegions()
    if (this.fleet.ValidInType === 'PLACES') {
      this.getUserPlaces({ region: this.region })
    } else if (this.fleet.ValidInType === 'ZONES') {
      this.getUserZones({ region: this.region })
    }
    if (this.userRegions.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      this.region = this.userRegions[0]
      this.showUserRegionsSelect = false
    }

    await this.getAvailableApplications()
    if (this.availableApplications.length) {
      // eslint-disable-next-line prefer-destructuring
      this.appId = this.availableApplications[0].ID
      if (this.availableApplications.length === 1) {
        this.showApplicationSelect = false
      } else if (this.availableApplications.length > 1) {
        this.showApplicationSelect = true
      }
    }

    await this.getUsers()

    this.localLoading = false
  },
  methods: {
    ...mapActions('app', ['getAvailableApplications']),
    ...mapActions('users', [
      'getUserRegions',
      'getUserPlaces',
      'getUserZones',
      'getUsers'
    ]),
    ...mapActions('fleets', ['getFleet']),
    ...mapMutations('fleets', ['setFleetValue']),
    getAppNameByAppId(id) {
      const appInAvailableApplications = this.availableApplications.find(
        app => {
          return app.ID === id
        }
      )
      return appInAvailableApplications
        ? appInAvailableApplications.ShortName
        : 'Barking'
    },
    setRestrictedToFleetUser(manager, fleetUserId) {
      // manager.RestrictedToFleetUserId = fleetUserId
      this.$store.commit('fleets/setFleetManagerRestrictedToFleetUserId', {
        id: manager.ID,
        key: 'RestrictedToFleetUserId',
        value: Number(fleetUserId)
      })
    },
    removeSelectedManager(item) {
      this.$store.commit('fleets/removeManagerFromFleetManagersArray', item)
    }
  }
}
</script>
<style>
::v-deep .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 0px !important;
}
.highlight:hover {
  background: lightgray !important;
}
</style>
